<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="winter-neva-gradient">
      <mdb-modal-title tag="div">
        <a v-if="!!event.url" @click="linkClick(event.url)">
          <h3 class="m-0 d-inline-block">{{ event.title }}</h3>
          <mdb-icon icon="external-link-alt" class="ml-2 fa-2x"/>
        </a>
        <h3 v-else class="m-0">{{ event.title }}</h3>
      </mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-tbl class="props-table">
          <mdb-tbl-head>
            <tr>
              <td>From:</td><td>{{ event && event.start && formatDateTime(event.start) }}</td>
            </tr>
            <tr v-if="event && event.end">
              <td>To:</td><td>{{ event && event.end && formatDateTime(event.end) }}</td>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(data, key) in properties" :key="`row-${key}`">
              <td>{{ key }}:</td><td>{{ data }}</td>
            </tr>
            <tr>
              <td class="pt-4">Status:</td>
              <td class="pt-3">
                <mdb-select
                  outline
                  :disabled="statuses.length === 1"
                  class="type-select no-margin-select"
                  :label="null"
                  v-model="statuses"
                  @getValue="close($event)"
                />
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn-group>
        <mdb-btn
          rounded
          size="sm"
          icon="edit"
          gradient="aqua"
          @click.native="edit()"
          title="Edit event"
        >Edit</mdb-btn>
        <mdb-btn
          rounded
          size="sm"
          icon="times"
          gradient="sunny-morning"
          @click.native="close()"
          title="Close"
        >Close</mdb-btn>
      </mdb-btn-group>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbBtnGroup,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbIcon,
  mdbSelect
} from 'mdbvue'
import {formatDate} from '@fullcalendar/core'
import {errorCatch} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'EventInfoModal',
  data () {
    return {
      show: false,
      event: {},
      callback: newStatus => { console.log('New status:', newStatus) },
      statuses: []
    }
  },
  props: {
    statusesInfo: {
      type: Array,
      required: true
    }
  },
  computed: {
    properties: {
      get () {
        const props = Object.assign({}, this.event.extendedProperties)
        delete props.status
        return props
      }
    }
  },
  methods: {
    ...mapActions(['apiEventUpdate']),
    linkClick (url) {
      window.open(url)
    },
    close (newStatus = null) {
      if (newStatus) {
        this.callback(newStatus)
      }
      this.show = false
      this.event = {}
      this.callback = newStatus => { console.log('New status:', newStatus) }
    },
    edit () {
      this.$bus.$emit(
        'modal-event-edit',
        {
          event: this.event,
          callback: data => {
            this.apiEventUpdate(data)
              .then(() => {
                this.$notify.success({
                  title: 'Event updated.',
                  message: '',
                  position: 'top right',
                  timeOut: 5000,
                  closeButton: true
                })
                this.$bus.$emit('calendar-refresh')
              })
              .catch(errorCatch('Event Update failed', this))
          }
        }
      )
      this.event = {}
      this.show = false
    },
    formatDateTime (obj) {
      return formatDate(obj, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false,
        omitCommas: true
      })
    }
  },
  mounted () {
    this.$bus.$on('modal-event-info', ({event, callback}) => {
      this.event = event
      this.callback = callback
      this.show = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal-event-info')
  },
  watch: {
    event: {
      handler: function () {
        this.statuses = this.event && this.event.extendedProps && this.statusesInfo ? [
          {
            text: this.event.extendedProps.status.name,
            value: this.event.extendedProps.status.code,
            selected: true
          },
          ...this.statusesInfo.find(si => si.code === this.event.extendedProps.status.code).available.map(st => {
            return {
              text: st.name,
              value: st.code
            }
          })
        ] : []
      }
    }
  },
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbBtnGroup,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbIcon,
    mdbSelect
  }
}
</script>

<style lang="sass" scoped>
.modal-body
  height: 50vh

.props-table
  td:first-child
    text-align: right
  td:last-child
    text-align: left
</style>



// WEBPACK FOOTER //
// src/components/EventInfoModal.vue